<template v-if="row" v-slot:row-details="row" @clicked="row.toggleDetails" >
  <div>
    <b-row class="mb-2">
      <b-col sm="2" class="text-sm-right"><b>Adresse</b></b-col>
      <b-col>
        {{ row.item.school.name }}<br/>
        {{ row.item.school.address }}<br/>
        {{ row.item.school.zip }} {{ row.item.school.city }}<br/>
      </b-col>

      <b-col sm="2" class="text-sm-right"><b>Anmeldungen</b></b-col>
      <b-col>
        <ul class="pl-0">
          <li v-for="group in row.item.registrations.groups">
            {{ group.ageGroup }}:
            <span :class="row.item.deletedAt ? 'text-line-through' : ''">
              {{ group.count }} Schüler ({{ group.type == 'online' ? 'Online' : 'Papier'}})
            </span>
          </li>
        </ul>
      </b-col>

    </b-row>

    <b-row class="mb-2">
      <b-col sm="2" class="text-sm-right"><b>Rechnungsadresse</b></b-col>
      <b-col>
        <p v-if="row.item.invoiceAddress">
          {{row.item.invoiceAddress.recipient}}<br/>
          {{row.item.invoiceAddress.line1}}<br/>
          <span v-if="row.item.invoiceAddress.line2">{{row.item.invoiceAddress.line2}}<br/></span>
          <span v-if="row.item.invoiceAddress.line3">{{row.item.invoiceAddress.line3}}<br/></span>
          {{row.item.invoiceAddress.zip}} {{row.item.invoiceAddress.city}}
        </p>
      </b-col>

      <b-col sm="2" class="text-sm-right"><b>Koordinator</b></b-col>
      <b-col>
        <span v-if="row.item.school.coordinatorId">
          <router-link :to="{name: 'admin.users.details', params: {id: row.item.school.coordinatorId}}">
            {{ row.item.coordinator.gender == 'male' ? 'Herr' : 'Frau' }}
            {{ row.item.coordinator.firstname }} {{ row.item.coordinator.lastname }}
          </router-link>

          <a v-b-tooltip.hover :href="'mailto:' + row.item.coordinator.email" :title="row.item.coordinator.email" class="ml-1">
            <font-awesome-icon :icon="['far', 'envelope']"></font-awesome-icon>
          </a>
        </span>
        <span v-else>(gelöschter Benutzer)</span>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols=12 class="text-right">
        <b-button variant="danger" size="sm" v-on:click.stop="$emit('delete', row.item.id)">
          <font-awesome-icon icon="trash-alt"></font-awesome-icon>
        </b-button>

        <b-button type="button" size="sm" v-on:click.stop="$emit('edit', row.item.id)">
          <font-awesome-icon icon="edit"></font-awesome-icon>
        </b-button>
      </b-col>
    </b-row>

  </div>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
library.add(faEnvelope)

export default {
  name: 'RegistrationRowDetails',
  props: ['row']
}
</script>

<style scoped>
ul {
  list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/admin/registration/RowDetails.vue